
<template>
   <div class="custom-acomplete"
        :class="{
            'custom-acomplete_type_focus':isFocus,
            'custom-acomplete_type_disabled':disabled
        }"
    >
        <label v-if="label" class="custom-acomplete__label" v-html="label">
        </label>
        <div class="custom-acomplete__input" v-click-outside="()=>{handleChanefocuse(false)}">
            <div :class="['custom-input', inputClass || 'size_large', {'custom-input_type_focus': isFocus, 'disabled': disabled}]">
                <div class="custom-input__input" @click="handleInputClick">
                    <input
                        ref="input"
                        type="text"
                        :value="value.text"
                        :placeholder="placeholder"
                        :disabled="disabled"
                        :maxlength="maxlength"
                        @input="handlerInput($event.target.value)"
                        @focus="handleChanefocuse(true)"
                        @blur="handleChanefocuse(false)"
                    />
                    <v-button
                        v-if="buttonIcon || isload"
                        type="button"
                        class="custom-input__button button_type_icon button_type_static"
                        :loading="isload"
                        :disabled="disabled || isload"
                        :class="buttonIconClass"
                        @click.stop="$emit('listButtonClick', value)"
                    >
                        <svg aria-hidden="true" v-if="buttonIcon" :width="iconSize.w" :height="iconSize.h">
                            <use :href="buttonIcon"></use>
                        </svg>
                    </v-button>
                </div>
            </div>

            <v-list
                class="dropList_size_full-width"
                :list="list"
                :expand="isFocus && !disabled && !!list.length"
                @listButtonClick="$emit('listButtonClick',$event)"
                @click="handleClickList($event)"
            />
        </div>

        <transition name="grow">
            <div v-if="error" class="validation__label validation__label_type_error">
                {{error}}
            </div>
        </transition>
        <transition name="grow">
            <div v-if="notes" class="validation__label">
                {{notes}}
            </div>
        </transition>
    </div>
</template>

<script>
import vList from './DropDownList'
import vButton from './vButton.vue'

export default {
    name: 'vCustomAutocompleteNoMask',
    props: {
        isload: {
            type: Boolean,
            default: false
        },
        buttonIcon: {
            type: String,
            default: ''
        },
        buttonIconClass: {
            type: Object,
            default: () => {}
        },
        inputClass: {
            type: Object,
            default: () => {}
        },
        notes: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        error: {
            type: [String, Boolean],
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        },
        value: {
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: ''
        },
        iconSize: {
            type: Object,
            default: function() {
                return { w: 16, h: 16 }
            }
        },
        maxlength: {
            type: Number,
            default: null
        }
    },
    components: {
        vList,
        vButton
    },
    data() {
        return {
            isFocus: false,
        }
    },
    mounted() {
        this.$refs.input.addEventListener('paste', this.onPaste)
    },
    methods: {
        onPaste(event) {
            this.handlerInput(event.clipboardData.getData('Text'))
        },
        handleClickList(event) {
            this.$emit('input', event)
            this.$emit('update', event)
            this.handleChanefocuse(false)
        },
        handleInputClick() {
            this.isFocus = true
            this.$emit('toggleFocuse', this.isFocus)
        },
        handlerInput(event) {
            if (!this.list.length) {
                this.$emit('input', { id: null, text: event })
                return
            }
            let newItem = null
            this.list.some(item => {
                const isinList = item.text == event
                if (isinList) {
                    newItem = item
                }
                return isinList
            })

            if (newItem) {
                this.$emit('input', newItem)
            } else {
                this.$emit('input', { id: null, text: event })
            }
        },
        handleChanefocuse(value) {
            this.isFocus = (value && !this.$props.disabled)
            this.$emit('toggleFocuse', this.isFocus)
        }
    }
}
</script>